/**
 * Generated by orval v8.20.0 🍺
 * Do not edit manually.
 * Smart Sash Admin API
 * RESTful API for Smart Sash device management, user authentication, and system administration
 * OpenAPI spec version: 0.13.0.0
 */
import {
  useInfiniteQuery,
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  GetApiPortalMeSessionsParams,
  GetApiPortalMeSessionsSummaryParams,
  PortalIssueCreatedDto,
  PortalIssueRequest,
  PortalPlaybackDto,
  PortalSessionDetailDto,
  PortalSessionFiltersDto,
  PortalSessionListDto,
  PortalSummaryDto,
  ProblemDetails
} from '../../models';

import { customInstance } from '../../../http/customInstance';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getApiPortalMeSessions = (
    params?: GetApiPortalMeSessionsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<PortalSessionListDto>(
      {url: `/api/portal/me/sessions`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetApiPortalMeSessionsInfiniteQueryKey = (params?: GetApiPortalMeSessionsParams,) => {
    return [
    'infinite', `/api/portal/me/sessions`, ...(params ? [params] : [])
    ] as const;
    }

export const getGetApiPortalMeSessionsQueryKey = (params?: GetApiPortalMeSessionsParams,) => {
    return [
    `/api/portal/me/sessions`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetApiPortalMeSessionsInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getApiPortalMeSessions>>>, TError = PortalSessionListDto | ProblemDetails | unknown | null>(params?: GetApiPortalMeSessionsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiPortalMeSessions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiPortalMeSessionsInfiniteQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiPortalMeSessions>>> = ({ signal }) => getApiPortalMeSessions(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiPortalMeSessions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiPortalMeSessionsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getApiPortalMeSessions>>>
export type GetApiPortalMeSessionsInfiniteQueryError = PortalSessionListDto | ProblemDetails | unknown | null


export function useGetApiPortalMeSessionsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiPortalMeSessions>>>, TError = PortalSessionListDto | ProblemDetails | unknown | null>(
 params: undefined |  GetApiPortalMeSessionsParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiPortalMeSessions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiPortalMeSessions>>,
          TError,
          Awaited<ReturnType<typeof getApiPortalMeSessions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiPortalMeSessionsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiPortalMeSessions>>>, TError = PortalSessionListDto | ProblemDetails | unknown | null>(
 params?: GetApiPortalMeSessionsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiPortalMeSessions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiPortalMeSessions>>,
          TError,
          Awaited<ReturnType<typeof getApiPortalMeSessions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiPortalMeSessionsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiPortalMeSessions>>>, TError = PortalSessionListDto | ProblemDetails | unknown | null>(
 params?: GetApiPortalMeSessionsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiPortalMeSessions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiPortalMeSessionsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiPortalMeSessions>>>, TError = PortalSessionListDto | ProblemDetails | unknown | null>(
 params?: GetApiPortalMeSessionsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiPortalMeSessions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiPortalMeSessionsInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetApiPortalMeSessionsQueryOptions = <TData = Awaited<ReturnType<typeof getApiPortalMeSessions>>, TError = PortalSessionListDto | ProblemDetails | unknown | null>(params?: GetApiPortalMeSessionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiPortalMeSessions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiPortalMeSessionsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiPortalMeSessions>>> = ({ signal }) => getApiPortalMeSessions(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiPortalMeSessions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiPortalMeSessionsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiPortalMeSessions>>>
export type GetApiPortalMeSessionsQueryError = PortalSessionListDto | ProblemDetails | unknown | null


export function useGetApiPortalMeSessions<TData = Awaited<ReturnType<typeof getApiPortalMeSessions>>, TError = PortalSessionListDto | ProblemDetails | unknown | null>(
 params: undefined |  GetApiPortalMeSessionsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiPortalMeSessions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiPortalMeSessions>>,
          TError,
          Awaited<ReturnType<typeof getApiPortalMeSessions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiPortalMeSessions<TData = Awaited<ReturnType<typeof getApiPortalMeSessions>>, TError = PortalSessionListDto | ProblemDetails | unknown | null>(
 params?: GetApiPortalMeSessionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiPortalMeSessions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiPortalMeSessions>>,
          TError,
          Awaited<ReturnType<typeof getApiPortalMeSessions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiPortalMeSessions<TData = Awaited<ReturnType<typeof getApiPortalMeSessions>>, TError = PortalSessionListDto | ProblemDetails | unknown | null>(
 params?: GetApiPortalMeSessionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiPortalMeSessions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiPortalMeSessions<TData = Awaited<ReturnType<typeof getApiPortalMeSessions>>, TError = PortalSessionListDto | ProblemDetails | unknown | null>(
 params?: GetApiPortalMeSessionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiPortalMeSessions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiPortalMeSessionsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiPortalMeSessionsSummary = (
    params?: GetApiPortalMeSessionsSummaryParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<PortalSummaryDto>(
      {url: `/api/portal/me/sessions/summary`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetApiPortalMeSessionsSummaryInfiniteQueryKey = (params?: GetApiPortalMeSessionsSummaryParams,) => {
    return [
    'infinite', `/api/portal/me/sessions/summary`, ...(params ? [params] : [])
    ] as const;
    }

export const getGetApiPortalMeSessionsSummaryQueryKey = (params?: GetApiPortalMeSessionsSummaryParams,) => {
    return [
    `/api/portal/me/sessions/summary`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetApiPortalMeSessionsSummaryInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getApiPortalMeSessionsSummary>>>, TError = PortalSummaryDto | ProblemDetails | unknown | null>(params?: GetApiPortalMeSessionsSummaryParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiPortalMeSessionsSummary>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiPortalMeSessionsSummaryInfiniteQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiPortalMeSessionsSummary>>> = ({ signal }) => getApiPortalMeSessionsSummary(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiPortalMeSessionsSummary>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiPortalMeSessionsSummaryInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getApiPortalMeSessionsSummary>>>
export type GetApiPortalMeSessionsSummaryInfiniteQueryError = PortalSummaryDto | ProblemDetails | unknown | null


export function useGetApiPortalMeSessionsSummaryInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiPortalMeSessionsSummary>>>, TError = PortalSummaryDto | ProblemDetails | unknown | null>(
 params: undefined |  GetApiPortalMeSessionsSummaryParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiPortalMeSessionsSummary>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiPortalMeSessionsSummary>>,
          TError,
          Awaited<ReturnType<typeof getApiPortalMeSessionsSummary>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiPortalMeSessionsSummaryInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiPortalMeSessionsSummary>>>, TError = PortalSummaryDto | ProblemDetails | unknown | null>(
 params?: GetApiPortalMeSessionsSummaryParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiPortalMeSessionsSummary>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiPortalMeSessionsSummary>>,
          TError,
          Awaited<ReturnType<typeof getApiPortalMeSessionsSummary>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiPortalMeSessionsSummaryInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiPortalMeSessionsSummary>>>, TError = PortalSummaryDto | ProblemDetails | unknown | null>(
 params?: GetApiPortalMeSessionsSummaryParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiPortalMeSessionsSummary>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiPortalMeSessionsSummaryInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiPortalMeSessionsSummary>>>, TError = PortalSummaryDto | ProblemDetails | unknown | null>(
 params?: GetApiPortalMeSessionsSummaryParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiPortalMeSessionsSummary>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiPortalMeSessionsSummaryInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetApiPortalMeSessionsSummaryQueryOptions = <TData = Awaited<ReturnType<typeof getApiPortalMeSessionsSummary>>, TError = PortalSummaryDto | ProblemDetails | unknown | null>(params?: GetApiPortalMeSessionsSummaryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiPortalMeSessionsSummary>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiPortalMeSessionsSummaryQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiPortalMeSessionsSummary>>> = ({ signal }) => getApiPortalMeSessionsSummary(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiPortalMeSessionsSummary>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiPortalMeSessionsSummaryQueryResult = NonNullable<Awaited<ReturnType<typeof getApiPortalMeSessionsSummary>>>
export type GetApiPortalMeSessionsSummaryQueryError = PortalSummaryDto | ProblemDetails | unknown | null


export function useGetApiPortalMeSessionsSummary<TData = Awaited<ReturnType<typeof getApiPortalMeSessionsSummary>>, TError = PortalSummaryDto | ProblemDetails | unknown | null>(
 params: undefined |  GetApiPortalMeSessionsSummaryParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiPortalMeSessionsSummary>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiPortalMeSessionsSummary>>,
          TError,
          Awaited<ReturnType<typeof getApiPortalMeSessionsSummary>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiPortalMeSessionsSummary<TData = Awaited<ReturnType<typeof getApiPortalMeSessionsSummary>>, TError = PortalSummaryDto | ProblemDetails | unknown | null>(
 params?: GetApiPortalMeSessionsSummaryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiPortalMeSessionsSummary>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiPortalMeSessionsSummary>>,
          TError,
          Awaited<ReturnType<typeof getApiPortalMeSessionsSummary>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiPortalMeSessionsSummary<TData = Awaited<ReturnType<typeof getApiPortalMeSessionsSummary>>, TError = PortalSummaryDto | ProblemDetails | unknown | null>(
 params?: GetApiPortalMeSessionsSummaryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiPortalMeSessionsSummary>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiPortalMeSessionsSummary<TData = Awaited<ReturnType<typeof getApiPortalMeSessionsSummary>>, TError = PortalSummaryDto | ProblemDetails | unknown | null>(
 params?: GetApiPortalMeSessionsSummaryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiPortalMeSessionsSummary>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiPortalMeSessionsSummaryQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiPortalMeSessionsFilters = (

 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<PortalSessionFiltersDto>(
      {url: `/api/portal/me/sessions/filters`, method: 'GET', signal
    },
      options);
    }




export const getGetApiPortalMeSessionsFiltersInfiniteQueryKey = () => {
    return [
    'infinite', `/api/portal/me/sessions/filters`
    ] as const;
    }

export const getGetApiPortalMeSessionsFiltersQueryKey = () => {
    return [
    `/api/portal/me/sessions/filters`
    ] as const;
    }


export const getGetApiPortalMeSessionsFiltersInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getApiPortalMeSessionsFilters>>>, TError = ProblemDetails | unknown | null>( options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiPortalMeSessionsFilters>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiPortalMeSessionsFiltersInfiniteQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiPortalMeSessionsFilters>>> = ({ signal }) => getApiPortalMeSessionsFilters(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiPortalMeSessionsFilters>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiPortalMeSessionsFiltersInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getApiPortalMeSessionsFilters>>>
export type GetApiPortalMeSessionsFiltersInfiniteQueryError = ProblemDetails | unknown | null


export function useGetApiPortalMeSessionsFiltersInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiPortalMeSessionsFilters>>>, TError = ProblemDetails | unknown | null>(
  options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiPortalMeSessionsFilters>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiPortalMeSessionsFilters>>,
          TError,
          Awaited<ReturnType<typeof getApiPortalMeSessionsFilters>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiPortalMeSessionsFiltersInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiPortalMeSessionsFilters>>>, TError = ProblemDetails | unknown | null>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiPortalMeSessionsFilters>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiPortalMeSessionsFilters>>,
          TError,
          Awaited<ReturnType<typeof getApiPortalMeSessionsFilters>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiPortalMeSessionsFiltersInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiPortalMeSessionsFilters>>>, TError = ProblemDetails | unknown | null>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiPortalMeSessionsFilters>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiPortalMeSessionsFiltersInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiPortalMeSessionsFilters>>>, TError = ProblemDetails | unknown | null>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiPortalMeSessionsFilters>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiPortalMeSessionsFiltersInfiniteQueryOptions(options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetApiPortalMeSessionsFiltersQueryOptions = <TData = Awaited<ReturnType<typeof getApiPortalMeSessionsFilters>>, TError = ProblemDetails | unknown | null>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiPortalMeSessionsFilters>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiPortalMeSessionsFiltersQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiPortalMeSessionsFilters>>> = ({ signal }) => getApiPortalMeSessionsFilters(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiPortalMeSessionsFilters>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiPortalMeSessionsFiltersQueryResult = NonNullable<Awaited<ReturnType<typeof getApiPortalMeSessionsFilters>>>
export type GetApiPortalMeSessionsFiltersQueryError = ProblemDetails | unknown | null


export function useGetApiPortalMeSessionsFilters<TData = Awaited<ReturnType<typeof getApiPortalMeSessionsFilters>>, TError = ProblemDetails | unknown | null>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiPortalMeSessionsFilters>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiPortalMeSessionsFilters>>,
          TError,
          Awaited<ReturnType<typeof getApiPortalMeSessionsFilters>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiPortalMeSessionsFilters<TData = Awaited<ReturnType<typeof getApiPortalMeSessionsFilters>>, TError = ProblemDetails | unknown | null>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiPortalMeSessionsFilters>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiPortalMeSessionsFilters>>,
          TError,
          Awaited<ReturnType<typeof getApiPortalMeSessionsFilters>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiPortalMeSessionsFilters<TData = Awaited<ReturnType<typeof getApiPortalMeSessionsFilters>>, TError = ProblemDetails | unknown | null>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiPortalMeSessionsFilters>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiPortalMeSessionsFilters<TData = Awaited<ReturnType<typeof getApiPortalMeSessionsFilters>>, TError = ProblemDetails | unknown | null>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiPortalMeSessionsFilters>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiPortalMeSessionsFiltersQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiPortalMeSessionsId = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<PortalSessionDetailDto>(
      {url: `/api/portal/me/sessions/${id}`, method: 'GET', signal
    },
      options);
    }




export const getGetApiPortalMeSessionsIdInfiniteQueryKey = (id: string,) => {
    return [
    'infinite', `/api/portal/me/sessions/${id}`
    ] as const;
    }

export const getGetApiPortalMeSessionsIdQueryKey = (id: string,) => {
    return [
    `/api/portal/me/sessions/${id}`
    ] as const;
    }


export const getGetApiPortalMeSessionsIdInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getApiPortalMeSessionsId>>>, TError = ProblemDetails | unknown | null | PortalSessionDetailDto>(id: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiPortalMeSessionsId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiPortalMeSessionsIdInfiniteQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiPortalMeSessionsId>>> = ({ signal }) => getApiPortalMeSessionsId(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiPortalMeSessionsId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiPortalMeSessionsIdInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getApiPortalMeSessionsId>>>
export type GetApiPortalMeSessionsIdInfiniteQueryError = ProblemDetails | unknown | null | PortalSessionDetailDto


export function useGetApiPortalMeSessionsIdInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiPortalMeSessionsId>>>, TError = ProblemDetails | unknown | null | PortalSessionDetailDto>(
 id: string, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiPortalMeSessionsId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiPortalMeSessionsId>>,
          TError,
          Awaited<ReturnType<typeof getApiPortalMeSessionsId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiPortalMeSessionsIdInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiPortalMeSessionsId>>>, TError = ProblemDetails | unknown | null | PortalSessionDetailDto>(
 id: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiPortalMeSessionsId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiPortalMeSessionsId>>,
          TError,
          Awaited<ReturnType<typeof getApiPortalMeSessionsId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiPortalMeSessionsIdInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiPortalMeSessionsId>>>, TError = ProblemDetails | unknown | null | PortalSessionDetailDto>(
 id: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiPortalMeSessionsId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiPortalMeSessionsIdInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiPortalMeSessionsId>>>, TError = ProblemDetails | unknown | null | PortalSessionDetailDto>(
 id: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiPortalMeSessionsId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiPortalMeSessionsIdInfiniteQueryOptions(id,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetApiPortalMeSessionsIdQueryOptions = <TData = Awaited<ReturnType<typeof getApiPortalMeSessionsId>>, TError = ProblemDetails | unknown | null | PortalSessionDetailDto>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiPortalMeSessionsId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiPortalMeSessionsIdQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiPortalMeSessionsId>>> = ({ signal }) => getApiPortalMeSessionsId(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiPortalMeSessionsId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiPortalMeSessionsIdQueryResult = NonNullable<Awaited<ReturnType<typeof getApiPortalMeSessionsId>>>
export type GetApiPortalMeSessionsIdQueryError = ProblemDetails | unknown | null | PortalSessionDetailDto


export function useGetApiPortalMeSessionsId<TData = Awaited<ReturnType<typeof getApiPortalMeSessionsId>>, TError = ProblemDetails | unknown | null | PortalSessionDetailDto>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiPortalMeSessionsId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiPortalMeSessionsId>>,
          TError,
          Awaited<ReturnType<typeof getApiPortalMeSessionsId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiPortalMeSessionsId<TData = Awaited<ReturnType<typeof getApiPortalMeSessionsId>>, TError = ProblemDetails | unknown | null | PortalSessionDetailDto>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiPortalMeSessionsId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiPortalMeSessionsId>>,
          TError,
          Awaited<ReturnType<typeof getApiPortalMeSessionsId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiPortalMeSessionsId<TData = Awaited<ReturnType<typeof getApiPortalMeSessionsId>>, TError = ProblemDetails | unknown | null | PortalSessionDetailDto>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiPortalMeSessionsId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiPortalMeSessionsId<TData = Awaited<ReturnType<typeof getApiPortalMeSessionsId>>, TError = ProblemDetails | unknown | null | PortalSessionDetailDto>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiPortalMeSessionsId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiPortalMeSessionsIdQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiPortalMeSessionsIdPlayback = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<PortalPlaybackDto>(
      {url: `/api/portal/me/sessions/${id}/playback`, method: 'GET', signal
    },
      options);
    }




export const getGetApiPortalMeSessionsIdPlaybackInfiniteQueryKey = (id: string,) => {
    return [
    'infinite', `/api/portal/me/sessions/${id}/playback`
    ] as const;
    }

export const getGetApiPortalMeSessionsIdPlaybackQueryKey = (id: string,) => {
    return [
    `/api/portal/me/sessions/${id}/playback`
    ] as const;
    }


export const getGetApiPortalMeSessionsIdPlaybackInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getApiPortalMeSessionsIdPlayback>>>, TError = ProblemDetails | unknown | null | PortalPlaybackDto>(id: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiPortalMeSessionsIdPlayback>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiPortalMeSessionsIdPlaybackInfiniteQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiPortalMeSessionsIdPlayback>>> = ({ signal }) => getApiPortalMeSessionsIdPlayback(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiPortalMeSessionsIdPlayback>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiPortalMeSessionsIdPlaybackInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getApiPortalMeSessionsIdPlayback>>>
export type GetApiPortalMeSessionsIdPlaybackInfiniteQueryError = ProblemDetails | unknown | null | PortalPlaybackDto


export function useGetApiPortalMeSessionsIdPlaybackInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiPortalMeSessionsIdPlayback>>>, TError = ProblemDetails | unknown | null | PortalPlaybackDto>(
 id: string, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiPortalMeSessionsIdPlayback>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiPortalMeSessionsIdPlayback>>,
          TError,
          Awaited<ReturnType<typeof getApiPortalMeSessionsIdPlayback>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiPortalMeSessionsIdPlaybackInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiPortalMeSessionsIdPlayback>>>, TError = ProblemDetails | unknown | null | PortalPlaybackDto>(
 id: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiPortalMeSessionsIdPlayback>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiPortalMeSessionsIdPlayback>>,
          TError,
          Awaited<ReturnType<typeof getApiPortalMeSessionsIdPlayback>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiPortalMeSessionsIdPlaybackInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiPortalMeSessionsIdPlayback>>>, TError = ProblemDetails | unknown | null | PortalPlaybackDto>(
 id: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiPortalMeSessionsIdPlayback>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiPortalMeSessionsIdPlaybackInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiPortalMeSessionsIdPlayback>>>, TError = ProblemDetails | unknown | null | PortalPlaybackDto>(
 id: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiPortalMeSessionsIdPlayback>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiPortalMeSessionsIdPlaybackInfiniteQueryOptions(id,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetApiPortalMeSessionsIdPlaybackQueryOptions = <TData = Awaited<ReturnType<typeof getApiPortalMeSessionsIdPlayback>>, TError = ProblemDetails | unknown | null | PortalPlaybackDto>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiPortalMeSessionsIdPlayback>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiPortalMeSessionsIdPlaybackQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiPortalMeSessionsIdPlayback>>> = ({ signal }) => getApiPortalMeSessionsIdPlayback(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiPortalMeSessionsIdPlayback>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiPortalMeSessionsIdPlaybackQueryResult = NonNullable<Awaited<ReturnType<typeof getApiPortalMeSessionsIdPlayback>>>
export type GetApiPortalMeSessionsIdPlaybackQueryError = ProblemDetails | unknown | null | PortalPlaybackDto


export function useGetApiPortalMeSessionsIdPlayback<TData = Awaited<ReturnType<typeof getApiPortalMeSessionsIdPlayback>>, TError = ProblemDetails | unknown | null | PortalPlaybackDto>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiPortalMeSessionsIdPlayback>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiPortalMeSessionsIdPlayback>>,
          TError,
          Awaited<ReturnType<typeof getApiPortalMeSessionsIdPlayback>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiPortalMeSessionsIdPlayback<TData = Awaited<ReturnType<typeof getApiPortalMeSessionsIdPlayback>>, TError = ProblemDetails | unknown | null | PortalPlaybackDto>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiPortalMeSessionsIdPlayback>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiPortalMeSessionsIdPlayback>>,
          TError,
          Awaited<ReturnType<typeof getApiPortalMeSessionsIdPlayback>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiPortalMeSessionsIdPlayback<TData = Awaited<ReturnType<typeof getApiPortalMeSessionsIdPlayback>>, TError = ProblemDetails | unknown | null | PortalPlaybackDto>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiPortalMeSessionsIdPlayback>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiPortalMeSessionsIdPlayback<TData = Awaited<ReturnType<typeof getApiPortalMeSessionsIdPlayback>>, TError = ProblemDetails | unknown | null | PortalPlaybackDto>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiPortalMeSessionsIdPlayback>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiPortalMeSessionsIdPlaybackQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const postApiPortalMeSessionsIdIssue = (
    id: string,
    portalIssueRequest?: PortalIssueRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<PortalIssueCreatedDto>(
      {url: `/api/portal/me/sessions/${id}/issue`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: portalIssueRequest, signal
    },
      options);
    }




export const getPostApiPortalMeSessionsIdIssueMutationOptions = <TError = PortalIssueCreatedDto | ProblemDetails | unknown | null,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiPortalMeSessionsIdIssue>>, TError,{id: string;data?: PortalIssueRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiPortalMeSessionsIdIssue>>, TError,{id: string;data?: PortalIssueRequest}, TContext> => {

const mutationKey = ['postApiPortalMeSessionsIdIssue'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiPortalMeSessionsIdIssue>>, {id: string;data?: PortalIssueRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  postApiPortalMeSessionsIdIssue(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiPortalMeSessionsIdIssueMutationResult = NonNullable<Awaited<ReturnType<typeof postApiPortalMeSessionsIdIssue>>>
    export type PostApiPortalMeSessionsIdIssueMutationBody = PortalIssueRequest | undefined
    export type PostApiPortalMeSessionsIdIssueMutationError = PortalIssueCreatedDto | ProblemDetails | unknown | null

    export const usePostApiPortalMeSessionsIdIssue = <TError = PortalIssueCreatedDto | ProblemDetails | unknown | null,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiPortalMeSessionsIdIssue>>, TError,{id: string;data?: PortalIssueRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiPortalMeSessionsIdIssue>>,
        TError,
        {id: string;data?: PortalIssueRequest},
        TContext
      > => {
      return useMutation(getPostApiPortalMeSessionsIdIssueMutationOptions(options), queryClient);
    }
    export const getApiPortalMeSessionsSampleRecording = (

 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/api/portal/me/sessions/sample-recording`, method: 'GET', signal
    },
      options);
    }




export const getGetApiPortalMeSessionsSampleRecordingInfiniteQueryKey = () => {
    return [
    'infinite', `/api/portal/me/sessions/sample-recording`
    ] as const;
    }

export const getGetApiPortalMeSessionsSampleRecordingQueryKey = () => {
    return [
    `/api/portal/me/sessions/sample-recording`
    ] as const;
    }


export const getGetApiPortalMeSessionsSampleRecordingInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getApiPortalMeSessionsSampleRecording>>>, TError = ProblemDetails>( options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiPortalMeSessionsSampleRecording>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiPortalMeSessionsSampleRecordingInfiniteQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiPortalMeSessionsSampleRecording>>> = ({ signal }) => getApiPortalMeSessionsSampleRecording(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiPortalMeSessionsSampleRecording>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiPortalMeSessionsSampleRecordingInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getApiPortalMeSessionsSampleRecording>>>
export type GetApiPortalMeSessionsSampleRecordingInfiniteQueryError = ProblemDetails


export function useGetApiPortalMeSessionsSampleRecordingInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiPortalMeSessionsSampleRecording>>>, TError = ProblemDetails>(
  options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiPortalMeSessionsSampleRecording>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiPortalMeSessionsSampleRecording>>,
          TError,
          Awaited<ReturnType<typeof getApiPortalMeSessionsSampleRecording>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiPortalMeSessionsSampleRecordingInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiPortalMeSessionsSampleRecording>>>, TError = ProblemDetails>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiPortalMeSessionsSampleRecording>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiPortalMeSessionsSampleRecording>>,
          TError,
          Awaited<ReturnType<typeof getApiPortalMeSessionsSampleRecording>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiPortalMeSessionsSampleRecordingInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiPortalMeSessionsSampleRecording>>>, TError = ProblemDetails>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiPortalMeSessionsSampleRecording>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiPortalMeSessionsSampleRecordingInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiPortalMeSessionsSampleRecording>>>, TError = ProblemDetails>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiPortalMeSessionsSampleRecording>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiPortalMeSessionsSampleRecordingInfiniteQueryOptions(options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetApiPortalMeSessionsSampleRecordingQueryOptions = <TData = Awaited<ReturnType<typeof getApiPortalMeSessionsSampleRecording>>, TError = ProblemDetails>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiPortalMeSessionsSampleRecording>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiPortalMeSessionsSampleRecordingQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiPortalMeSessionsSampleRecording>>> = ({ signal }) => getApiPortalMeSessionsSampleRecording(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiPortalMeSessionsSampleRecording>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiPortalMeSessionsSampleRecordingQueryResult = NonNullable<Awaited<ReturnType<typeof getApiPortalMeSessionsSampleRecording>>>
export type GetApiPortalMeSessionsSampleRecordingQueryError = ProblemDetails


export function useGetApiPortalMeSessionsSampleRecording<TData = Awaited<ReturnType<typeof getApiPortalMeSessionsSampleRecording>>, TError = ProblemDetails>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiPortalMeSessionsSampleRecording>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiPortalMeSessionsSampleRecording>>,
          TError,
          Awaited<ReturnType<typeof getApiPortalMeSessionsSampleRecording>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiPortalMeSessionsSampleRecording<TData = Awaited<ReturnType<typeof getApiPortalMeSessionsSampleRecording>>, TError = ProblemDetails>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiPortalMeSessionsSampleRecording>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiPortalMeSessionsSampleRecording>>,
          TError,
          Awaited<ReturnType<typeof getApiPortalMeSessionsSampleRecording>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiPortalMeSessionsSampleRecording<TData = Awaited<ReturnType<typeof getApiPortalMeSessionsSampleRecording>>, TError = ProblemDetails>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiPortalMeSessionsSampleRecording>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiPortalMeSessionsSampleRecording<TData = Awaited<ReturnType<typeof getApiPortalMeSessionsSampleRecording>>, TError = ProblemDetails>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiPortalMeSessionsSampleRecording>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiPortalMeSessionsSampleRecordingQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






